import React from "react";
import {
  Icon, IconButton, Input, InputGroup, InputLeftElement, InputRightElement, useColorModeValue,
} from "@chakra-ui/react";
import { MdClose, MdSearch } from "react-icons/md";
import Card from "horizon/components/card/Card";

/**
 * Controlled search input for the services view. The data hook owns the 300ms
 * debounce — this component is purely presentational.
 * @param {Object} props - value (string), onChange (fn called with new query)
 * @returns {React.ReactElement}
 */
function ServicesSearchBar({ value, onChange }) {
  const iconColor = useColorModeValue("secondaryGray.600", "secondaryGray.400");
  const textColor = useColorModeValue("secondaryGray.900", "white");
  return (
    <Card>
      <InputGroup>
        <InputLeftElement pointerEvents="none">
          <Icon as={MdSearch} color={iconColor} w="20px" h="20px" />
        </InputLeftElement>
        <Input value={value} onChange={(e) => onChange(e.target.value)} color={textColor}
          placeholder="Rechercher par artiste, email ou pays..." borderRadius="12px" />
        {value ? (
          <InputRightElement>
            <IconButton aria-label="Effacer" size="sm" variant="ghost" color={iconColor}
              icon={<Icon as={MdClose} />} onClick={() => onChange("")} />
          </InputRightElement>
        ) : null}
      </InputGroup>
    </Card>
  );
}

export default ServicesSearchBar;
